import { IconButton, Theme } from '@mui/material';
import React from 'react';
import Colors from '../../utils/color';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  iconButtonClass: {
    width: '32px',
    height: '100%',
    padding: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    margin: '0px !important',
    flexShrink: 0,
  },
  iconComponentClass: {
    width: '100% !important',
    // Smaller box (32x32 inactive, square => no distortion) with tighter
    // padding => smaller icons sitting closer together.
    height: (props: any) =>
      props.isActive ? '42px !important' : '32px !important',
    padding: (props: any) => (props.isActive ? '2px' : '4px'),
    borderRadius: '4px',
  },
}));

export interface IVisualIndicator {
  IconComponent: React.ElementType;
  onClick?: (event?: any) => void;
  isActive?: boolean;
  customizedColor?: string;
  id?: string;
}

const VisualIndicator = (props: IVisualIndicator) => {
  const { iconButtonClass, iconComponentClass } = useStyles(props);
  const { onClick, IconComponent, id, customizedColor, isActive } = props;

  return (
    <IconButton id={id} className={iconButtonClass} onClick={onClick}>
      <IconComponent
        fontSize="small"
        className={iconComponentClass}
        sx={{
          color: customizedColor
            ? customizedColor
            : isActive
            ? Colors.brightGreen
            : Colors.dim,
        }}
      />
    </IconButton>
  );
};

export default VisualIndicator;
